export const formatLogs = ({ logSessionList = [], logList = [] }) =>
  logSessionList.map((e) => ({
    ...e,
    logList: Array.isArray(e.logList)
      ? e.logList.map((l) => logList.find((k) => k.id === l.id))
      : [],
  }));
